"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var react_transition_group_1 = require("react-transition-group");
var Portal_1 = require("../base/Portal");
var OPEN_DRAWERS = 0;
var TRANSITION_DURATION = 200;
var Drawer = /** @class */ (function (_super) {
    tslib_1.__extends(Drawer, _super);
    function Drawer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onCloseClick = function (e) {
            var exitOnClickOutside = _this.props.exitOnClickOutside;
            if (_this.isClickOutside(e.target) && exitOnClickOutside) {
                _this.close();
            }
        };
        _this.setPanelRef = function (el) {
            _this.$panel = el;
        };
        _this.$panel = null;
        _this.state = { mounted: false };
        _this.initialize();
        return _this;
    }
    Drawer.prototype.initialize = function () {
        this.handleOpenState({});
    };
    Drawer.prototype.componentDidMount = function () {
        this.setState({ mounted: true });
    };
    Drawer.prototype.componentWillUnmount = function () {
        if (this.props.isOpen) {
            OPEN_DRAWERS--;
            this.enableScroll();
        }
    };
    Drawer.prototype.componentDidUpdate = function (prevProps) {
        this.handleOpenState(prevProps);
    };
    Drawer.prototype.handleOpenState = function (prevProps) {
        var lockDocumentScroll = this.props.lockDocumentScroll;
        if (!lockDocumentScroll) {
            return;
        }
        if (this.props.isOpen && !prevProps.isOpen) {
            OPEN_DRAWERS++;
            this.disableScroll();
        }
        if (!this.props.isOpen && prevProps.isOpen) {
            OPEN_DRAWERS--;
            this.enableScroll();
        }
    };
    Drawer.prototype.enableScroll = function () {
        var _this = this;
        if (OPEN_DRAWERS > 0 || this.props.preventDisableScroll) {
            return;
        }
        setTimeout(function () {
            if (_this.context.enablePageScroll) {
                _this.context.enablePageScroll();
            }
        }, TRANSITION_DURATION);
    };
    Drawer.prototype.disableScroll = function () {
        if (OPEN_DRAWERS > 1 || this.props.preventDisableScroll) {
            return;
        }
        var disablePageScroll = this.context.disablePageScroll;
        if (disablePageScroll) {
            return disablePageScroll();
        }
    };
    Drawer.prototype.isClickOutside = function (target) {
        return (!this.$panel ? true : !this.$panel.contains(target));
    };
    Drawer.prototype.close = function () {
        var onClose = this.props.onClose;
        onClose();
    };
    Drawer.prototype.renderDrawer = function () {
        var _a;
        var _b = this.props, children = _b.children, theme = _b.theme, className = _b.className, isOpen = _b.isOpen, backdrop = _b.backdrop, position = _b.position, exitOnClickOutside = _b.exitOnClickOutside, panelStyle = _b.panelStyle, panelClass = _b.panelClass, onClose = _b.onClose, others = tslib_1.__rest(_b, ["children", "theme", "className", "isOpen", "backdrop", "position", "exitOnClickOutside", "panelStyle", "panelClass", "onClose"]);
        var classes = classnames_1.default(theme.drawer, className, theme[position], (_a = {},
            _a[theme["no-pointer-events"]] = !exitOnClickOutside,
            _a));
        var panelClasses = classnames_1.default(theme.panel, panelClass);
        return (React.createElement("div", { className: classes, onClick: this.onCloseClick },
            backdrop ? React.createElement("div", { className: theme.backdrop }) : null,
            React.createElement("div", { className: panelClasses, ref: this.setPanelRef, style: panelStyle }, children)));
    };
    Drawer.prototype.render = function () {
        var _a = this.props, theme = _a.theme, isOpen = _a.isOpen;
        var mounted = this.state.mounted;
        var transitionClasses = {
            enter: theme.drawerEnter,
            enterActive: theme.drawerEnterActive,
            exit: theme.drawerLeave,
            exitActive: theme.drawerLeaveActive
        };
        return (React.createElement(Portal_1.default, null,
            React.createElement(react_transition_group_1.CSSTransition, { in: isOpen && mounted, unmountOnExit: true, classNames: transitionClasses, timeout: TRANSITION_DURATION }, this.renderDrawer())));
    };
    Drawer.defaultProps = {
        isOpen: true,
        onClose: utils_1.noop,
        backdrop: true,
        exitOnClickOutside: true,
        position: "right",
        lockDocumentScroll: true
    };
    Drawer.contextTypes = {
        disablePageScroll: PropTypes.func,
        enablePageScroll: PropTypes.func
    };
    return Drawer;
}(React.Component));
exports.default = Drawer;
